import Vue from 'vue';
import SkyNews from './sky-news';

Vue.component('sky-news', SkyNews);

export default SkyNews;



// WEBPACK FOOTER //
// ./scripts/sky-news/index.js